export type Action<T extends string = string> = {
  type: T
}

/**
 * @param obj The object to inspect.
 * @returns True if the argument appears to be a plain object.
 */
const isPlainObject = (obj: unknown): obj is object => {
  if (typeof obj !== 'object' || obj === null) return false

  let proto = obj
  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto) as object
  }

  return (
    Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null
  )
}

export const isAction = (action: unknown): action is Action<string> => {
  return (
    isPlainObject(action) &&
    'type' in action &&
    typeof (action as Record<'type', unknown>).type === 'string'
  )
}
